import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield } from 'lucide-react';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 30;
          seconds = 5;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-8 px-4 bg-white border-y-4 border-brand-gold/30 scroll-mt-4" data-id="element-125">
      <div className="max-w-2xl mx-auto" data-id="element-126">
        <div className="text-center mb-4" data-id="element-127">
          <p className="text-sm font-extrabold text-brand-gold uppercase tracking-widest mb-1" data-id="element-128">
            SPECIAL OFFER — COMPLETE 6-IN-1 PACK
          </p>
          <p className="text-base font-bold text-brand-graphite/90 mb-3" data-id="element-129">
            Access the system now and transform your classes today
          </p>
          <div className="inline-block bg-brand-petrol text-white px-4 py-1.5 rounded-md shadow-md mb-4" data-id="element-130">
            <p className="font-bold text-base tracking-wide" data-id="element-131">
              Yoga Ready 6-in-1 Box Set
            </p>
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/4bHTedV1cSBKAqW87FCj9F/ChatGPT_Image_14_jun_2026,_12_05_24_a.m..png" alt="Yoga Ready 6-in-1 Box Set" className="w-full max-w-xs mx-auto object-contain drop-shadow-xl mb-4" data-id="element-132" />
        </div>

        <div className="bg-brand-cream border-4 border-brand-gold rounded-xl p-4 sm:p-6 text-center relative mb-4 shadow-2xl" data-id="element-133">
          <div className="mb-4" data-id="element-134">
            <p className="text-sm sm:text-base font-bold text-brand-graphite/70 mb-1" data-id="element-135">
              Normal Price: <span className="line-through" data-id="element-136">$97 USD</span>
            </p>
            <p className="text-lg sm:text-xl font-extrabold text-red-600 mb-2 uppercase tracking-wide" data-id="element-137">
              🔥 72% OFF — LAUNCH OFFER
            </p>
            <p className="text-5xl sm:text-6xl font-serif font-extrabold text-brand-graphite mb-1" data-id="element-138">
              $27 USD
            </p>
            <p className="text-xs sm:text-sm font-bold text-brand-graphite/60 uppercase tracking-wider" data-id="element-139">
              Pay in your local currency
            </p>
          </div>

          <div className="bg-red-50 border-2 border-red-200 rounded-lg p-3 mb-5" data-id="element-140">
            <p className="text-sm font-bold text-red-600 mb-2 uppercase tracking-wide" data-id="element-141">
              🔥 Last chance! The price increases when the timer ends.
            </p>
            <div className="flex justify-center gap-3" data-id="element-142">
              <div className="text-center" data-id="element-143">
                <div className="bg-brand-graphite text-white text-xl sm:text-2xl font-bold px-3 py-1.5 rounded shadow-inner" data-id="element-144">
                  {String(timeLeft.hours).padStart(2, '0')}
                </div>
                <p className="text-[10px] font-bold text-brand-graphite/70 mt-1 tracking-wider" data-id="element-145">
                  HOURS
                </p>
              </div>
              <div className="text-xl font-bold text-brand-graphite mt-1.5" data-id="element-146">
                :
              </div>
              <div className="text-center" data-id="element-147">
                <div className="bg-brand-graphite text-white text-xl sm:text-2xl font-bold px-3 py-1.5 rounded shadow-inner" data-id="element-148">
                  {String(timeLeft.minutes).padStart(2, '0')}
                </div>
                <p className="text-[10px] font-bold text-brand-graphite/70 mt-1 tracking-wider" data-id="element-149">
                  MINUTES
                </p>
              </div>
              <div className="text-xl font-bold text-brand-graphite mt-1.5" data-id="element-150">
                :
              </div>
              <div className="text-center" data-id="element-151">
                <div className="bg-brand-graphite text-white text-xl sm:text-2xl font-bold px-3 py-1.5 rounded shadow-inner" data-id="element-152">
                  {String(timeLeft.seconds).padStart(2, '0')}
                </div>
                <p className="text-[10px] font-bold text-brand-graphite/70 mt-1 tracking-wider" data-id="element-153">
                  SECONDS
                </p>
              </div>
            </div>
          </div>

          <CTAButton href="https://yoga.impultienda.ar/checkout" className="!bg-brand-gold !text-brand-graphite border-none shadow-[0_4px_14px_0_rgba(200,168,107,0.39)] hover:shadow-[0_6px_20px_rgba(200,168,107,0.23)] hover:bg-brand-gold/90" data-id="element-154">
            🚀 YES, I WANT THE 6-IN-1 PACK ($27)
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-5 gap-y-1 text-sm text-brand-graphite font-bold" data-id="element-155">
          <div className="flex items-center gap-1" data-id="element-156">
            <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-157" />
            <span data-id="element-158">4.9/5 — Verified Reviews</span>
          </div>
          <span className="hidden sm:inline text-brand-gold" data-id="element-159">•</span>
          <div className="flex items-center gap-1" data-id="element-160">
            <Shield className="w-4 h-4 text-brand-petrol" data-id="element-161" />
            <span data-id="element-162">7-Day Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}